module.exports = __webpack_public_path__ + "img/logo2.0a1aacad.png";